import { FEE_RATE, MIN_FEE_USD } from '../constants';

export function getUsdPrice(byId, coingeckoId) {
  const p = byId?.[coingeckoId]?.usd;
  if (typeof p === 'number' && p > 0) return p;
  if (coingeckoId === 'tether') return 1;
  return null;
}

// Shared fee rate resolver so both directions compute the fee the same way:
// a flat percentage from profitPercent, no minimum. Falls back to the
// FEE_RATE constant only if profitPercent isn't provided/valid.
function resolveFeeRate(profitPercent) {
  const pct = Number(profitPercent);
  if (Number.isFinite(pct) && pct > 0) {
    return pct / 100;
  }
  const fallback = Number(FEE_RATE);
  if (Number.isFinite(fallback) && fallback > 0) {
    return fallback;
  }
  return 0;
}

export function quoteSendToSomalia({ amount, asset, byId, profitPercent }) {
  const num = Number.parseFloat(String(amount || ''));
  if (!Number.isFinite(num) || num <= 0) return null;

  const price = getUsdPrice(byId, asset.coingeckoId);
  if (price === null) return null;

  const feeRate = resolveFeeRate(profitPercent);

  const grossUsd = num * price;
  const fee = grossUsd * feeRate;
  const payoutUsd = grossUsd - fee;
  if (payoutUsd <= 0) return null;

  return { grossUsd, fee, payoutUsd, price };
}

export function quoteFundWallet({ amount, asset, byId, profitPercent }) {
  const num = Number.parseFloat(String(amount || ''));
  if (!Number.isFinite(num) || num <= 0) return null;

  const price = getUsdPrice(byId, asset.coingeckoId);
  if (price === null) return null;

  const feeRate = resolveFeeRate(profitPercent);

  const fee = num * feeRate;
  const netUsd = num - fee;
  if (netUsd <= 0) return null;

  const cryptoOut = netUsd / price;

  return { fee, netUsd, cryptoOut, price };
}
